import { render } from "./ComposeComponent.vue?vue&type=template&id=01c7593e"
import script from "./ComposeComponent.vue?vue&type=script&lang=js"
export * from "./ComposeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__